import { render } from "./MyWorkInside.vue?vue&type=template&id=0b1d1797&scoped=true"
import script from "./MyWorkInside.vue?vue&type=script&lang=js"
export * from "./MyWorkInside.vue?vue&type=script&lang=js"

import "./MyWorkInside.vue?vue&type=style&index=0&id=0b1d1797&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1d1797"]])

export default __exports__